(function( global, $ ) {
    $(document).ready(function () {
        $('[data-alert-session]').each(function() {
            var alertName = $(this).data('alertSession');

            if(!sessionStorage.getItem(alertName)) {
                $(this).removeClass('d-none');
            }
            
            $(this).on('closed.bs.alert', function () {
                sessionStorage.setItem(alertName, 'closed');
            })
        });
    });
}( window.groots, jQuery ));